import z from "zod";

import {
  BACKGROUND_EFFECTS,
  BACKGROUND_FADES,
  BACKGROUND_PATTERNS,
  BACKGROUND_POSITIONS,
} from "./constants";

// Absent means "on" for these two: they are on by default in React, and an
// attribute nobody wrote should not flip that.
const booleanAttribute = z
  .string()
  .optional()
  .transform((value) => value !== "false");

export const backgroundDataSchema = z.object({
  effect: z.enum(BACKGROUND_EFFECTS).optional(),
  position: z.enum(BACKGROUND_POSITIONS).optional(),
  fade: z.enum(BACKGROUND_FADES).optional(),
  color: z.string().optional(),
  count: z.coerce.number().optional(),
  duration: z.coerce.number().optional(),
  intensity: z.coerce.number().optional(),
  beamWidth: z.coerce.number().optional(),
  rails: booleanAttribute,
  pattern: z.enum(BACKGROUND_PATTERNS).optional(),
  cellSize: z.coerce.number().optional(),
  spotlight: booleanAttribute,
  spotlightSize: z.coerce.number().optional(),
  repel: booleanAttribute,
  repelRadius: z.coerce.number().optional(),
  repelStrength: z.coerce.number().optional(),
});

export type BackgroundDataProps = z.infer<typeof backgroundDataSchema>;
